<template>
  <div id="zt8228">
    <div id="k1">
      <div>
        <label>ZT8228</label>
        <label>Full vision, New touch</label>
        <label>6'' water-drop screen & narrow frame design, unusual visual and tactile experience</label>
        <span>
          <!-- <img :src="require('@/assets/pic/zt8228/icons.png')" /> -->
        </span>
      </div>
      <!-- <img :src="require('@/assets/pic/zt8228/bgcv1.png')" /> -->
    </div>
    <div id="k2">
      <img :src="require('@/assets/pic/zt8228/icon1.png')"/>
      <img :src="require('@/assets/pic/zt8228/icon2.png')"/>
      <img :src="require('@/assets/pic/zt8228/icon3.png')"/>
    </div>
    <div id="k3">
      <div>Modular splicing design</div>
      <div>Removable module design, free combination according to different occasions</div>
      <!-- <img :src="require('@/assets/pic/zt8228/bgcv2.png')" /> -->
    </div>
    <div id="k4">
      <div>Ultra-thin body，one-hand operation</div>
      <div>16.8mm ultra-thin body & more in line with ergonomics, for better grip</div>
      <!-- <img :src="require('@/assets/pic/zt8228/bgcv2.png')" /> -->
    </div>
    <payscene :data="sdata"></payscene>
    <pdpp :data="ppdata"></pdpp>
    <pdspecs :data="$store.state.iscn?spdata:spdata_en"></pdspecs>
  </div>
</template>

<script>
import payscene from '@/components/payscene'
import pdpp from '@/components/pdpp'
import pdspecs from '@/components/pdspecs'
export default {
  name: '',
  components: {
    payscene,pdpp,pdspecs
  },
  props: {
    data: Object
  },
  watch: {
    
  },
  data () {
    var _this = this
    return {
      sdata: {
        title: 'Pay unbounded as you have ',
        data: [
          {
            pic: require('@/assets/pic/zt8228/p1.png'),
            label: 'QR'
          },
          {
            pic: require('@/assets/pic/zt8228/p2.png'),
            label: 'Magetic'
          },
          {
            pic: require('@/assets/pic/zt8228/p3.png'),
            label: 'Fingerprint'
          },
        ]
      },
      ppdata: {
        desc: 'Thermal Printer、Fingerprint Reader、Fiscal Box、Encrypted Pinpad',
        data: [
          {
            pic: require('@/assets/pic/zt8228/pt1.png'),
            label: 'Thermal printer'
          },
          {
            pic: require('@/assets/pic/zt8228/pt2.png'),
            label: 'Fingerprint Reader'
          },
          {
            pic: require('@/assets/pic/zt8228/pt3.png'),
            label: 'Encrypted Pinpad'
          }
        ]
      },
      spdata: {
        file: 'zt8228',
        data: [ 
          {label: '处理器', desc: ['CPU采用ARM架构硬件平台','4核Cortex-A53@1.5Ghz'],pic: 'cpu.png'},
          {label: '存储器', desc: ['1GB RAM +8GB ROM','2GB RAM +16GB ROM（选配）', '最大可扩展为3GB RAM +32GB ROM'],pic: 'ram.png'},
          {label: '操作系统', desc: ['Android 11','证通安全操作系统（ZOS）'], pic: 'sys.png'},
          {label: '显示屏', desc: ['6”水滴屏', '1520×720 TFT LCD'], pic: 'disp.png'},
          {label: '摄像头', desc: ['前置：500万像素','后置：800万像素 ，带闪光灯', '最大帧数 30帧/秒'], pic: 'face.png'},
          {label: '触摸屏', desc: ['多点触控电容式触摸屏，支持触摸操作，符合银联电子签名规范'],pic: 'touch.png'},
          {label: '安全', desc: ['支持3DES、AES、RSA、SHA-256、SM2、SM3、SM4等算法'], pic: 'safe.png'},
          {label: '移动网络', desc: ['支持4G全网通(GSM, WCMDA, EVDO, TD-SCDMA, TD-LTE, FDD-LTE)'], pic: 'mobi.png'},
          {label: 'WIFI', desc: ['符合IEEE802.11 a/b/g/n', '频段：2.4GHz'], pic: 'wifi.png'},
          {label: '蓝牙', desc: ['支持蓝牙 4.1','支持BLE'], pic: 'blt.png'},
          {label: '定位', desc: ['内置GPS / 北斗 / Glonass','支持LBS功能','支持AGPS'], pic: 'lbs.png'},
          {label: '扫码器', desc: ['支持QR Code / EAN-13 / UPC-A / UPC-E / EAN-8 / Code 128 / Code39 / Interleaved 2of5'], pic: 'scan.png'},
          {label: '读卡器', desc: ['磁条卡读卡器×1、接触IC读卡器×1','非接IC读卡器×1'], pic: 'read.png'},
          {label: '打印机', desc: ['58mm热敏打印机(标配）','打印速度80mm / s，外径40mm纸卷', '支持80mm打印纸（选配）'], pic: 'prt.png'},
          {label: '指纹组件（选配）', desc: ['支持光学式、电容式指纹识别', '满足FBI指纹认证需求', '满足印度STQC认证需求'], pic: 'fgip.png'},
          {label: '税控组件（选配）', desc: ['支持拆机自毁功能', '安全存储128MB'], pic: 'tax1.png'},
          {label: '加密键盘（选配）', desc: ['安全密码键盘，符合PCI规范'], pic: 'keyb.png'},
          {label: '扬声器', desc: ['内置立体声双扬声器，功率1W'], pic: 'speaker.png'},
          {label: '接口', desc: ['TYPE-C USB×1', '兼容USB2.0HS标准'], pic: 'port.png'},
          {label: '按键', desc: ['电源键（开关机）×1', '功能键（音量键）×2'], pic: 'keyt.png'},
          {label: '适配器', desc: ['输入：AC 100-240V～50/60Hz 1A','输出：DC 5V/3 A'], pic: 'char.png'},
          {label: '尺寸（长×宽×高）', desc: ['220.0mm×78.0mm×16.8mm'], pic: 'size.png'},

        ]
      },
      spdata_en: {
        file: 'zt8228',
        data: [ 
          {label: 'Processor', desc: ['Quad-core','Cortex- A53@1.5Ghz'],pic: 'cpu.png'},
          {label: 'Memory', desc: ['1GB RAM +8GB ROM','2GB RAM +16GB ROM (optional)', 'support up to3GB RAM +32GB ROM'],pic: 'ram.png'},
          {label: 'OS', desc: ['ZOS based on Android 11'], pic: 'sys.png'},
          {label: 'Display', desc: ['6" water-drop screen', '1520 x 720TFT LCD'], pic: 'disp.png'},
          {label: 'Camera', desc: ['Rear: 5 M pixels','Rear: 8 M pixels, flash Up to 30 frames/sec'], pic: 'face.png'},
          {label: 'Touch screen', desc: ['Multi-touch capacitive screen'],pic: 'touch.png'},
          {label: 'Security', desc: ['3DES、AES、RSA、SHA-256、SM2、SM3、SM4，etc.'], pic: 'safe.png'},
          {label: 'Cellular Network', desc: ['GSM/ WCDMA/EVDO/TD-SCDMA/ TDD-LTE/FDD-LTE'], pic: 'mobi.png'},
          {label: 'WIFI', desc: ['IEEE 802.11b/g/n', '2.4GHz'], pic: 'wifi.png'},
          {label: 'Bluetooth', desc: ['Bluetooth 4.1','BLE'], pic: 'blt.png'},
          {label: 'Location', desc: ['Built-in GPS/Beidou/Glonass','LBS','AGPS'], pic: 'lbs.png'},
          {label: 'Codes type', desc: ['QR Code ,EAN- 13/UPC-A,UPC-E,EAN-8，Code 128,Code39，Interleaved 2of5'], pic: 'scan.png'},
          {label: 'Card Reader', desc: ['Magneticx1、ContactIC x1','Contactless IC x1'], pic: 'read.png'},
          {label: 'Printer', desc: ['58mm thermal printer(Standard)','Printing speed:80mm/s,40mm paper roll', '80mm paper roll support(optional)'], pic: 'prt.png'},
          {label: 'Fingerprint (optional)', desc: ['Optical, capacitive support', 'FBI complaint support', 'India STQC complaint support'], pic: 'fgip.png'},
          {label: 'Fiscal box ( optional)', desc: ['Support self-destruction', 'Whendisassembly', 'Secure storage 128mb'], pic: 'tax1.png'},
          {label: 'Keypad (optional)', desc: ['Encrypted Pinpad, PCI certified'], pic: 'keyb.png'},
          {label: 'Speaker', desc: ['Built-in speaker, 2W'], pic: 'speaker.png'},
          {label: 'Port', desc: ['TYPE-C USB×1'], pic: 'port.png'},
          {label: 'Button', desc: ['Power x1', 'Volume x2'], pic: 'keyt.png'},
          {label: 'Adapter', desc: ['Input: AC 100-240V ~ 50/60Hz 1A','Output: DC 5V/3 A'], pic: 'char.png'},
          {label: 'Dimension(LxWxH)', desc: ['220.0mm x78.0mm x 16.8mm'], pic: 'size.png'},

        ]
      }
    }
  },
  methods: {
  
  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#zt8228 {
  background: black;
  margin-top: -.93rem;
}
#k1 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8228/bg1.png');
  background-size: 100% 100%;
  overflow: hidden;
}
#k1 div {
  display: inline-block;
  vertical-align: top;
  margin-top: 2.55rem;
  margin-left: 3.72rem;
  /* width: 4.138rem; */
  color: white;
}
#k1 label {
  display: block;
  font-size: .55rem;
  font-weight: normal;
  font-weight: 800;
  color: #FFFFFF;
}
#k1 label:nth-child(3) {
  color: cyan;
  margin-top: .2rem;
  font-size: .36rem;
  font-weight: 400 !important;
  color: #FFFFFF;
  width: 9rem;
}


#k2 {
  background: #EAEAEA ;
  color: white;
  text-align: center;
  padding: .53rem 3.96rem .53rem 3.96rem;
  font-size: .24rem;
  font-weight: normal;
  line-height: .48rem;
}

#k2 img {
  margin-right: .3rem;
}

#k3 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8228/bg2.png');
  background-size: 100% 100%;
  color: white;
  overflow: hidden;
  padding-left: 3.46rem;
}
#k3 div:nth-child(1) {
  margin-top: 3.07rem;
  font-size: .58rem;
  font-weight: bold;
  color: #4C4D4C;
}
#k3 div:nth-child(2) {
  font-size: .36rem;
  font-weight: 500;
  color: #666666;
  width: 8rem;
  margin-top: .5rem;
}

#k3 img {
  width: 2.7rem;
  height: 3.89;
  margin-left: 8.4rem;
}

#k4 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8228/bg3.png');
  background-size: 100% 100%;
  color: white;
  overflow: hidden;
  padding-left: 3.46rem;
}
#k4 div:nth-child(1) {
  font-size: .6rem;
  font-weight: bold;
  color: #4D4D4D;
  width: 6rem;
  margin-top: 3.29rem;
}
#k4 div:nth-child(2) {
  font-size: .36rem;
  font-weight: 500;
  color: #666666;
  width: 6.2rem;
}



</style>
